import React from 'react';
import styles from './Footer.module.scss';
import config from 'config';

export const Footer: React.FC = () => {
  const envMap: Record<string, string> = {
    local: '-local',
    development: '-dev',
    uat: '-uat',
    production: '-prod'
  };

  return (
    <footer className={styles.footer} id="bottom">
      <div className={styles.disclaimer}>
        Powered by GenAI Lounge & Services
        <p className={styles.version}>{`v${config.APP.VERSION}${
          envMap[config.APP.ENVIRONMENT] || ''
        }`}</p>
      </div>
    </footer>
  );
};
